export const intercomId = 'xl2ojsh9';

const isLocalhost = window.location.host.startsWith('localhost:') || window.location.host.startsWith('127.0.0.1:');
const isNgrok = window.location.host.includes('.ngrok.io');

export let googlePlacesId = '';
export let apiUrl = '';
export let s3BucketName = '';
export let s3BucketRegion = '';
export let location = '';
let _googleAnalyticsAccountId = 'G-KFHBD09SJ1';
export let googleMapsMapId = '';
export const customerSuccessEmail = 'customer.success@yembo.ai';

export let isDeveloperMode = isLocalhost || isNgrok;
export let isDevEnvironment = false;
export let isCvdevEnvironment = false;
export let isStagingEnvironment = false;
export let isProdEnvironment = false;
export let isProdGovEnvironment = false;

switch (import.meta.env.REACT_APP_API_ENV) {
  // service-voyager-api running on this machine (its docker compose, port
  // 24060), against the dev database and dev bucket. `bun run dev:local`.
  case 'local': {
    googlePlacesId = 'AIzaSyA-aV9pvrHIhPr3zoiMlqWCZazTCg-Ll7A';
    apiUrl = 'http://localhost:24060';
    s3BucketName = 'yembo-voyager-dev';
    s3BucketRegion = 'us-east-1';
    isDeveloperMode = true;
    isDevEnvironment = true;
    location = 'us';
    googleMapsMapId = '96f0d110dd50c661';
    break;
  }
  case 'dev':
  case 'dev-beta':
  case 'dev_beta':
  case 'demo_alpha':
  case 'demo-alpha':
  case 'demo_beta':
  case 'demo-beta':
  case 'demo': {
    googlePlacesId = 'AIzaSyA-aV9pvrHIhPr3zoiMlqWCZazTCg-Ll7A';
    apiUrl = 'https://api.voyager.dev.yembo.ai';
    s3BucketName = 'yembo-voyager-dev';
    s3BucketRegion = 'us-east-1';
    isDeveloperMode = true;
    isDevEnvironment = true;
    location = 'us';
    googleMapsMapId = '96f0d110dd50c661';
    break;
  }
  case 'staging':
  case 'demo_gamma':
  case 'demo-gamma':
    googlePlacesId = 'AIzaSyA9TOaVhBlq5X9nwBshkFL6fIgz9WEpp6M';
    apiUrl = 'https://api.voyager.staging.yembo.ai';
    s3BucketName = 'yembo-voyager-staging';
    s3BucketRegion = 'us-east-1';
    isStagingEnvironment = true;
    location = 'us';
    googleMapsMapId = '97b542b7b9908c2b';
    break;
  case 'prod':
    googlePlacesId = 'AIzaSyAEkdAEOX0BsB3hViRMARynJ8MRMLnZqf0';
    apiUrl = 'https://api-us.voyager.yembo.ai';
    s3BucketName = 'yembo-voyager-prod';
    s3BucketRegion = 'us-east-1';
    isProdEnvironment = true;
    _googleAnalyticsAccountId = 'G-CML7YR6LK3';
    location = 'us';
    googleMapsMapId = '49795cb9479e2d84';
    break;
  case 'prod-ca':
  case 'prod_ca':
    googlePlacesId = 'AIzaSyAEkdAEOX0BsB3hViRMARynJ8MRMLnZqf0';
    apiUrl = 'https://api-ca.voyager.yembo.ai';
    s3BucketName = 'yembo-voyager-prod-ca';
    s3BucketRegion = 'ca-central-1';
    isProdEnvironment = true;
    _googleAnalyticsAccountId = 'G-CML7YR6LK3';
    location = 'ca';
    googleMapsMapId = '49795cb9479e2d84';
    break;
  case 'prod-eu':
  case 'prod_eu':
    googlePlacesId = 'AIzaSyAEkdAEOX0BsB3hViRMARynJ8MRMLnZqf0';
    apiUrl = 'https://api-eu.voyager.yembo.ai';
    s3BucketName = 'yembo-voyager-prod-eu';
    s3BucketRegion = 'eu-central-1';
    isProdEnvironment = true;
    _googleAnalyticsAccountId = 'G-CML7YR6LK3';
    location = 'eu';
    googleMapsMapId = '49795cb9479e2d84';
    break;
  case 'prod-sg':
  case 'prod_sg':
    googlePlacesId = 'AIzaSyAEkdAEOX0BsB3hViRMARynJ8MRMLnZqf0';
    apiUrl = 'https://api-sg.voyager.yembo.ai';
    s3BucketName = 'yembo-voyager-prod-sg';
    s3BucketRegion = 'ap-southeast-1';
    isProdEnvironment = true;
    _googleAnalyticsAccountId = 'G-CML7YR6LK3';
    location = 'sg';
    googleMapsMapId = '49795cb9479e2d84';
    break;
  case 'prod-gov':
  case 'prod_gov':
    googlePlacesId = 'AIzaSyAEkdAEOX0BsB3hViRMARynJ8MRMLnZqf0';
    apiUrl = 'https://api.yembogov.com';
    s3BucketName = 'yembo-voyager-prod-gov';
    s3BucketRegion = 'us-gov-west-1';
    isProdEnvironment = true;
    isProdGovEnvironment = true;
    _googleAnalyticsAccountId = 'G-CML7YR6LK3';
    location = 'us';
    googleMapsMapId = '49795cb9479e2d84';
    break;
  case 'cvdev1':
    apiUrl = 'http://localhost:2100';
    s3BucketName = 'yembo-voyager-cvdev';
    s3BucketRegion = 'us-east-1';
    isCvdevEnvironment = true;
    location = 'us';
    break;
  case 'cvdev2':
    apiUrl = 'http://localhost:2200';
    s3BucketName = 'yembo-voyager-cvdev';
    s3BucketRegion = 'us-east-1';
    isCvdevEnvironment = true;
    location = 'us';
    break;
  case 'cvdev3':
    apiUrl = 'http://localhost:2300';
    s3BucketName = 'yembo-voyager-cvdev';
    s3BucketRegion = 'us-east-1';
    isCvdevEnvironment = true;
    location = 'us';
    break;
  case 'cvdev4':
    apiUrl = 'http://localhost:2400';
    s3BucketName = 'yembo-voyager-cvdev';
    s3BucketRegion = 'us-east-1';
    isCvdevEnvironment = true;
    location = 'us';
    break;
  default:
    break;
}

// `./run.sh --api=local|cloud` passes the API URL from app/.env.<env>. Honored
// only by the Vite dev server: `import.meta.env.DEV` is replaced with `false` in
// `vite build`, so this branch (and the URL) is dropped from production builds,
// which always use the URLs above.
if (import.meta.env.DEV && import.meta.env.REACT_APP_API_URL) {
  apiUrl = import.meta.env.REACT_APP_API_URL.replace(/\/+$/, '');
}

export const installGoogleMaps = (): void => {
  const googleMapsScript = document.createElement('script');
  // Using Function.prototype as a noop callback helps to get rid of the Google Maps JS API error
  // https://stackoverflow.com/questions/75179573/how-to-fix-loading-the-google-maps-javascript-api-without-a-callback-is-not-supp
  googleMapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${googlePlacesId}&libraries=places,marker&language=en-US&loading=async&callback=Function.prototype`;
  googleMapsScript.type = 'text/javascript';
  googleMapsScript.async = true;
  googleMapsScript.defer = true;

  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(googleMapsScript, firstScript);
};
export const tinymceApiKey = 'wi65z7vn1a9weo71zrdbm0j7cjseq98wajeiovfvpgsyx4fu';
